import React from 'react';
import { Column, Row, Stack } from '@grubhubprod/gh-cookbook-react';
import { PageSectionTitle } from 'src/components/enterprise/layout/PageSectionTitle/PageSectionTitle';
import PageSection from 'src/components/enterprise/layout/PageSection';
import { PermissionsControlWrapper } from 'src/components/enterprise/features/Employee/components/Form/controls/PermissionsControlWrapper/PermissionsControlWrapper';
import { AllowAllocationsWrapper } from 'src/components/enterprise/features/Employee/components/Form/controls/AllowAllocationsWrapper/AllowAllocationsWrapper';

export const EmployeePermissions: React.FC = () => {
  return (
    <Stack y="md">
      <PageSection>
        <Stack y="sm">
          <PageSectionTitle title="Permissions" />
        </Stack>
        <Stack y="sm">
          <Row gutter={12}>
            <Column phone={4} gutter={12}>
              <PermissionsControlWrapper />
            </Column>
          </Row>
        </Stack>
        <Row>
          <Column phone={6}>
            <AllowAllocationsWrapper />
          </Column>
        </Row>
      </PageSection>
    </Stack>
  );
};
